import React from 'react';
import { AdaptiveFilterBar } from '@/shared/components/patterns';
import { ASSIGNMENT_URGENCY_META } from '@/modules/deals/utils';

const priorityOptions = Object.entries(ASSIGNMENT_URGENCY_META).map(([value, meta]) => ({
  value,
  label: String(meta.label || value).toLowerCase().replace(/^\w/, (char) => char.toUpperCase()),
}));

const dueDateOptions = [
  { value: 'overdue', label: 'Scadute' },
  { value: 'today', label: 'Oggi' },
  { value: 'next_7', label: 'Prossimi 7 giorni' },
  { value: 'next_30', label: 'Prossimi 30 giorni' },
  { value: 'none', label: 'Senza scadenza' },
];

function buildOptions(options = []) {
  return [
    { value: 'all', label: 'Tutte' },
    ...options,
  ];
}

function buildFilterConfig({ clients = [], suppliers = [], staff = [] } = {}) {
  return {
    search: {
      key: 'query',
      placeholder: 'Cerca task, cliente, mittente...',
    },
    groups: [
      {
        key: 'clientId',
        label: 'Cliente',
        selection: 'single',
        emptyValue: 'all',
        options: buildOptions(clients),
      },
      {
        key: 'supplierId',
        label: 'Fornitore',
        selection: 'single',
        emptyValue: 'all',
        options: [{ value: 'all', label: 'Tutti i fornitori' }, ...suppliers],
      },
      {
        key: 'dueDate',
        label: 'Scadenza',
        selection: 'single',
        emptyValue: 'all',
        options: buildOptions(dueDateOptions),
      },
      {
        key: 'urgency',
        label: 'Priorità',
        selection: 'single',
        emptyValue: 'all',
        options: buildOptions(priorityOptions),
      },
      {
        key: 'staffId',
        label: 'Personale coinvolto',
        selection: 'single',
        emptyValue: 'all',
        options: buildOptions(staff),
      },
    ],
  };
}

export default function AssignmentsFilters({ filters, options, onChange, onReset }) {
  return (
    <AdaptiveFilterBar
      config={buildFilterConfig(options)}
      values={filters}
      onChange={onChange}
      onReset={onReset}
      resetLabel="Reset filtri task"
      filtersLabel="Filtri task"
    />
  );
}
